import { CheckIcon, ClockIcon, XCircleIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { UserStatus } from '../../../../enums';

export default function Status({ status }: { status: string }) {
 
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-1 text-xs',
        {
          'bg-gray-100 text-gray-500': status === UserStatus.PENDING,
          'bg-green-500 text-white': status === UserStatus.ACTIVE,
          'bg-red-500 text-white': status === UserStatus.SUSPENDED,
        },
      )}
    >
      {status === UserStatus.PENDING ? (
        <>
          Pending
          <ClockIcon className="ml-1 w-4 text-gray-500" />
        </>
      ) : null}
      {status === UserStatus.ACTIVE ? (
        <>
          Active
          <CheckIcon className="ml-1 w-4 text-white" />
        </>
      ) : null}
      {status === UserStatus.SUSPENDED ? (
        <>
          Suspended
          <XCircleIcon className="ml-1 w-4 text-white" />
        </>
      ) : null}
    </span>
  );
}
